/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var LOOP_REPORT_TYPE;
(function (LOOP_REPORT_TYPE) {
    LOOP_REPORT_TYPE["STORE_PERFORMANCE"] = "store_performance";
    LOOP_REPORT_TYPE["ORDER_TRANSACTIONS_BY_MONTH"] = "order_transactions_by_month";
    LOOP_REPORT_TYPE["PAYOUTS_BY_PLATFORM"] = "payouts_by_platform";
    LOOP_REPORT_TYPE["TRANSACTIONS_BY_DATE"] = "transactions_by_date";
    LOOP_REPORT_TYPE["BANK_VERIFIED_PAYOUTS"] = "bank_verified_payouts";
    LOOP_REPORT_TYPE["CHARGEBACK_HISTORY_REPORT"] = "chargeback_history_report";
    LOOP_REPORT_TYPE["CHARGEBACK_ACTIVE_REPORT"] = "chargeback_active_report";
    LOOP_REPORT_TYPE["POS_PAYOUTS_WITH_TRANSACTIONS"] = "pos_payouts_with_transactions";
    LOOP_REPORT_TYPE["POS_3P_ORDERS_VARIANCE"] = "pos_3p_orders_variance";
    LOOP_REPORT_TYPE["TRANSACTIONS_ALL"] = "transactions_all";
    LOOP_REPORT_TYPE["OLO_ITEMS_86D"] = "olo_items_86d";
})(LOOP_REPORT_TYPE || (LOOP_REPORT_TYPE = {}));
